<template>
    <AppModal :title="title" ref="modal">
        <div class="modal-body">
            <slot>{{ text }}</slot>
        </div>
        <div class="modal-footer">
            <Button size="sm" color="light" @click="() => {$emit('canceled'), hide()}">
                {{ translate('buttons.no') }}
            </Button>
            <Button size="sm" color="indigo" @click="() => {$emit('confirmed'), hide()}" :disabled="disabledConfirmButton">
                {{ translate('buttons.yas') }}
            </Button>
        </div>
    </AppModal>
</template>
<script>
import AppModal from './AppModal.vue'
import Button from '../button/AppButton.vue'
export default {
    name: "ConfirmeModal",
    props: {
        title: {
            type: String
        },
        text: {
            type: String
        },
        disabledConfirmButton: {
            type: Boolean,
            default: false
        }
    },
    emits: ['confirmed', 'canceled'],
    components: {
        AppModal, Button
    },
    methods: {
        show() {
            this.$refs.modal.show()
        },
        hide() {
            this.$refs.modal.hide();
        }
    }
}
</script>
